import React from 'react';
import {
  IconBuilding,
  IconFileText,
  IconGrid,
  IconKey,
  IconReceipt,
  IconShield,
  IconTrend,
  IconUsers,
} from './ui/adminIcons';

export const ADMIN_HOME_PATH = '/admin/overview';

export const SECTION_TABS = [
  {
    id: 'overview',
    label: 'Overview',
    labelText: 'Platform overview',
    path: '/admin/overview',
    icon: <IconGrid title="Overview" />,
  },
  {
    id: 'users',
    label: 'Users',
    labelText: 'Users',
    path: '/admin/users',
    icon: <IconUsers title="Users" />,
  },
  {
    id: 'growth',
    label: 'Growth',
    labelText: 'Growth',
    path: '/admin/growth',
    icon: <IconTrend title="Growth" />,
  },
  {
    id: 'enterprise',
    label: 'Enterprise',
    labelText: 'Enterprise accounts',
    path: '/admin/enterprise',
    icon: <IconBuilding title="Enterprise" />,
  },
  {
    id: 'orders',
    label: 'Orders',
    labelText: 'Orders',
    path: '/admin/orders',
    icon: <IconReceipt title="Orders" />,
  },
  {
    id: 'cards',
    label: 'Cards',
    labelText: 'Physical cards',
    path: '/admin/cards',
    icon: <IconGrid title="Cards" />,
  },
  {
    id: 'applications',
    label: 'Membership Applications',
    labelText: 'Membership Applications',
    path: '/admin/applications',
    icon: <IconFileText title="Applications" />,
  },
  {
    id: 'security',
    label: 'Security',
    labelText: 'Security',
    path: '/admin/security',
    icon: <IconShield title="Security" />,
  },
  {
    id: 'staff',
    label: 'Staff',
    labelText: 'Staff and permissions',
    path: '/admin/staff',
    icon: <IconKey title="Staff" />,
  },
  {
    id: 'audit',
    label: 'Audit',
    labelText: 'Audit log',
    path: '/admin/audit',
    icon: <IconFileText title="Audit" />,
  },
  {
    id: 'promotions',
    label: 'Promotions',
    labelText: 'Promotional capacity',
    path: '/admin/promotions',
    icon: <IconTrend title="Promotions" />,
  },
];

export const SECTION_META = {
  overview: {
    title: 'Overview',
    subtitle: 'Live snapshot across the admin platform',
  },
  users: {
    title: 'Users',
    subtitle: 'Directory, sessions, geography, devices, and engagement',
  },
  growth: {
    title: 'Growth',
    subtitle: 'Signups, the guest-save funnel, and Pro and Teams waitlists',
  },
  enterprise: {
    title: 'Enterprise',
    subtitle: 'Commercial accounts · billing · access',
  },
  orders: {
    title: 'Orders',
    subtitle: 'Individual Shopify card purchases.',
  },
  cards: {
    title: 'Cards',
    subtitle: 'Physical card inventory, programming and assignment.',
  },
  fulfilment: {
    title: 'Fulfilment',
    subtitle: 'Programme, ship and review card orders from Shopify and the ledger.',
  },
  campaigns: {
    title: 'Campaigns',
    subtitle: 'Promotional batches and activation rates.',
  },
  applications: {
    title: 'Membership Applications',
    subtitle: 'Review applications, update status, add notes, export CSV.',
  },
  security: {
    title: 'Security',
    subtitle: 'Threat monitoring and access controls',
  },
  staff: {
    title: 'Staff',
    subtitle: 'Grant limited Velox access without making someone a super-admin',
  },
  audit: {
    title: 'Audit',
    subtitle: 'Privileged actions across companies, billing and staff',
  },
  promotions: {
    title: 'Promotions',
    subtitle: 'Campaign capacity that expires without changing the plan',
  },
};

export function sectionFromPath(pathname) {
  if (pathname.startsWith('/admin/security')) return 'security';
  if (pathname.startsWith('/admin/staff')) return 'staff';
  if (pathname.startsWith('/admin/audit')) return 'audit';
  if (pathname.startsWith('/admin/promotions')) return 'promotions';
  if (pathname.startsWith('/admin/applications')) return 'applications';
  if (pathname.startsWith('/admin/orders')) return 'orders';
  if (pathname.startsWith('/admin/cards')) return 'cards';
  if (pathname.startsWith('/admin/fulfilment')) return 'fulfilment';
  if (pathname.startsWith('/admin/campaigns')) return 'campaigns';
  if (pathname.startsWith('/admin/users')) return 'users';
  if (pathname.startsWith('/admin/growth')) return 'growth';
  if (pathname.startsWith('/admin/enterprise')) return 'enterprise';
  if (pathname.startsWith('/admin/overview')) return 'overview';
  if (pathname.startsWith('/admin/analytics')) return 'overview';
  return 'overview';
}
